const initialState = {
  reservations: [],
  pendingReservations: [],
};

export default initialState;
